export default "__VITE_ASSET__DzTIJA_Y__"